const Logo = (props) => {
  const { size = 1 } = props
  const width = `${Math.ceil(30 * size)}`
  const height = `${Math.ceil(30 * size)}`

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M24.9757 19.7219C25.541 18.357 25.832 16.8941 25.832 15.4167C25.832 12.4331 24.6468 9.57158 22.537 7.4618C20.4272 5.35201 17.5657 4.16675 14.582 4.16675C11.5983 4.16675 8.73686 5.35201 6.62708 7.4618C4.5173 9.57158 3.33203 12.4331 3.33203 15.4167C3.33203 16.8941 3.62302 18.357 4.18839 19.7219C4.75375 21.0868 5.58242 22.327 6.62708 23.3717C7.67174 24.4164 8.91193 25.245 10.2768 25.8104C11.6418 26.3758 13.1047 26.6667 14.582 26.6667C16.0594 26.6667 17.5223 26.3758 18.8872 25.8104C20.2521 25.245 21.4923 24.4164 22.537 23.3717C23.5816 22.327 24.4103 21.0868 24.9757 19.7219Z"
        fill="#20AB7C"
      />
      <path
        d="M10.832 15.8676L13.5354 18.402L18.942 13.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Logo
